import React from "react";
import * as Yup from "yup";
import CustomInput from "components/CustomInput/CustomInput";
import { useFormik } from "formik";
import TeamService from "services/TeamService";
import { useTeamContext } from "store/contexts/teamContext";
import { useTimelineContext } from "store/contexts/timelineContext";
import CustomTextArea from "components/CustomTextArea";
import AttachmentPreview from "components/AttachmentPreview/AttachmentPreview";
import AttachmentSelection from "components/AttachmentSelection/AttachmentSelection";
import ButtonWithProgress from "components/ButtonWithProgress";
import { useCreatePostContext } from "store/contexts/createPostContext";
import ChatGptAssistModal from "components/ChatGptAssistModal";

export default () => {
  const { handleClose } = useCreatePostContext();
  const { team } = useTeamContext();
  const { createPost } = useTimelineContext();
  const contentContainer = {
    display: "flex",
    flexDirection: "column",
  };

  const formik = useFormik({
    initialValues: {
      text: "",
      content: "",
      attachment: null,
    },
    validateOnBlur: false,
    validateOnMount: false,
    validateOnChange: false,
    validationSchema: Yup.object().shape(
      {
        text: Yup.string()
          .min(4)
          .max(250, "Topic should not be greater then 250")
          .required(),
        content: Yup.string().max(5000, "Content cannot be greater then 5000"),
        attachment: Yup.mixed().required(),
      },
      ["attachment", "text", "content"]
    ),
    onSubmit: async (values) => {
      try {
        const response = await TeamService.createSlideShow(
          team.id,
          values.text,
          values.content,
          values.attachment
        );

        formik.resetForm();
        handleClose();
        createPost(response.data.data);
      } catch (e) {
        console.log(e);
      }
    },
  });

  const onAttachmentSelected = (file) => {
    formik.setFieldValue("attachment", file);
  };

  const clearAttachment = () => {
    formik.setFieldValue("attachment", null);
  };

  const setValue = (value) => {
    formik.setFieldValue("text", value);
  };

  return (
    <section style={{ width: "100%" }}>
      <form noValidate onSubmit={formik.handleSubmit} className="creatingPost">
        <div style={contentContainer}>
          <div className="textAttachmentContent">
            <div className="text-area-create-post">
              <ChatGptAssistModal setValue={setValue} />
              <CustomTextArea
                secondErrorClass="textStyle"
                errorClass="textStyle"
                textAreaClass="slideShowTextArea create-text-padding"
                formik={formik}
                placeholder="Set the Topic for the Slide Show"
                fieldName={"text"}
                fieldName2={"attachment"}
              />
            </div>
            {!!formik.values.attachment && (
              <AttachmentPreview
                attachment={formik.values.attachment}
                clearAttachment={clearAttachment}
              />
            )}
          </div>
          <CustomInput
            inputClass="full_w slideShowContent"
            inputProps={{
              type: "text",
              placeholder: "Thoughts, Inspiration",
              ...formik.getFieldProps("content"),
              error: formik.errors.content,
            }}
          />
        </div>
        <div className="writepost-footer">
          <div className="writepost-left-btns">
            <ButtonWithProgress
              initialText={"Create"}
              buttonWithProgressClass="send-btn"
              isSubmitting={formik.isSubmitting}
            />
            <AttachmentSelection
              type="image"
              showSelectors={false}
              onChange={onAttachmentSelected}
              accepted={[".png", ".jpg", ".jpeg"]}
            />
          </div>
        </div>
      </form>
    </section>
  );
};
